import FileIcon from "./fileIcon"
import BellIcon from "./BellIcon"
import CupIcon from "./CupIcon"

export default {
    FileIcon,
    BellIcon,
    CupIcon
}